import { useEssentials } from 'hooks/utils/useEssentials'
import { TRANSLATION_KEYS } from 'locales/translation-keys'
import type { Insight } from './types'
import { InsightSection } from './insights-section/insight-section'
import { InsightsTab } from './utils'

const HEADING_ID = 'yesterday-at-a-glance-heading'

interface YesterdayAtAGlanceProps {
    insights: Insight[]
}

export const YesterdayAtAGlance = ({ insights }: YesterdayAtAGlanceProps) => {
    const { t } = useEssentials()
    const { insights: insightsKeys } = TRANSLATION_KEYS

    return (
        <InsightSection
            headingId={HEADING_ID}
            heading={t(insightsKeys.yesterdayAtAGlance)}
            insights={insights}
            tab={InsightsTab.Yesterday}
        />
    )
}
